import React, { ChangeEvent, ReactElement, useState } from 'react';
import './Feed.css';
import InvoicesFeedElement from './FeedElements/InvoicesFeedElement';
import { InvoiceSearchTokenModel } from '../../../Extensions/models/RecordSearchTokenModel';
import 'dayjs/locale/sr';
import SearchWindow from './SearchWindow';
import { RecordType } from '../../../Extensions/Extensions';

export default function InvoicesFeed(): ReactElement {
    const [query, setQuery] = useState<InvoiceSearchTokenModel>({
        searchText: '',
        startingDate: undefined,
        endingDate: undefined,
        lastEntityId: 0,
    });

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setQuery({ ...query, searchText: e.target.value, lastEntityId: 0 });
    };

    const handleStartDateChange = (date?: Date) => {
        setQuery({ ...query, startingDate: date as Date, lastEntityId: 0 });
    };

    const handleEndDateChange = (date?: Date) => {
        setQuery({ ...query, endingDate: date as Date, lastEntityId: 0 });
    };

    const setInvId = (invId: number) => {
        setQuery({ ...query, lastEntityId: invId });
    };

    return (
        <div style={{ overflowY: 'hidden' }}>
            <SearchWindow
                handleEndDateChange={handleEndDateChange}
                handleSearch={handleSearch}
                handleStartDateChange={handleStartDateChange}
                query={query}
                recordType={RecordType.Invoices}
            />
            <div className={'outter'}>
                <div className={'inner'}>
                    <InvoicesFeedElement setInvoiceId={setInvId} query={query} />
                </div>
            </div>
        </div>
    );
}
